import React from 'react';

const OrderStep = (props) => {
    return (
       <div className="order-step">
           <div className="d-none d-lg-block">
               <div className="d-flex flex-row align-items-center">                   
                   <div className="step-heading-text font-weight-heading-small col-lg-9 col-md-8">{props.itemValue}</div>
               </div>
           </div>
           <div className="d-lg-none">
             <div className="col-12">
                 <div className="d-flex flex-row">                     
                     <div className="step-heading-text font-weight-heading-small col-lg-9 col-md-8">{props.itemValue}</div>
                 </div>
             </div>
               <br/>
           </div>
       </div>
    )
}

export default OrderStep;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/OrderStep.js